import { FieldBase } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/FieldBase';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { RadioGroup, RadioGroupItem } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function SollstundenToggle() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <form.AppField
      name="bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden"
      listeners={{
        onChange() {
          ctx.resetDependentFields(
            'bezahlung.arbeitszeitkonto.gehaltsempfaenger.sollstunden',
          );
        },
      }}>
      {(field) => (
        <FieldBase>
          <RadioGroup
            value={field.state.value?.toString()}
            onValueChange={(e) => {
              field.handleChange(e === 'true');
            }}
            className="flex flex-row">
            <RadioGroupItem
              variant="card"
              layout="horizontal"
              label={t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.options.ja',
              )}
              value={'true'}
              className="w-full"
            />
            <RadioGroupItem
              variant="card"
              layout="horizontal"
              label={t(
                'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.sollstunden.options.nein',
              )}
              value={'false'}
              className="w-full"
            />
          </RadioGroup>
        </FieldBase>
      )}
    </form.AppField>
  );
}
